import React, {useEffect, useState} from "react";
import {Button, Input, Modal, Table} from "antd";
import {useAuth} from "oidc-react";
import SharedService from "../../../services/shared/service";

const CrewRecoveryPopup = ({
                               visible,
                               onClose,
                               recoveryData,
                               OnAddButtonClick,
                               recoveryIndexPopup,
                           }) => {
    const {userData} = useAuth();
    const token = userData?.access_token;

    const [isCrewTable, setIsCrewTable] = useState(false);
    const [crewItems, setCrewItems] = useState([]);
    const [selectedCrewData, setSelectedCrewData] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [listPagination, setListPagination] = useState({
        totalItemCount: 0,
        pageSize: 10,
        pageNumber: 1,
    });
    const [crewData, setCrewData] = useState({
        pcn: recoveryData[recoveryIndexPopup]?.RecoveryPCN?.value || "",
        forename: "",
        surname: "",
        rank: "",
        nationality: "",
    });

    useEffect(() => {
        if (listPagination.totalItemCount !== 0) {
            fetchRecoveryCrewSearch();
        }
    }, [listPagination.pageNumber]);

    const fetchRecoveryCrewSearch = async () => {
        setLoading(true);
        try {
            const response = await SharedService.post({
                token,
                url: "recovery/crew/search",
                data: crewData,
                params: {
                    pageNumber: listPagination.pageNumber,
                    pageSize: listPagination.pageSize,
                },
            });
            setCrewItems(response?.items ?? []);
            setListPagination((prev) => ({
                ...prev,
                totalItemCount: response?.totalItemCount ?? 0,
            }));
        } catch (error) {
            console.error("Seafarer search failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = () => {
        setIsCrewTable(true);
        setListPagination((prev) => ({...prev, pageNumber: 1}));
        fetchRecoveryCrewSearch();
    };

    const handleInputChange = (field) => (e) => {
        setCrewData((prev) => ({...prev, [field]: e.target.value}));
    };

    const handleTableChange = (pagination) => {
        setListPagination((prev) => ({...prev, pageNumber: pagination.current}));
    };

    const handlePopupCancel = () => {
        onClose?.();
    };

    const columns = [
        {title: "PCN", dataIndex: "pcn", key: "pcn"},
        {title: "First Name", dataIndex: "forename", key: "forename"},
        {title: "Last Name", dataIndex: "surname", key: "surname"},
        {title: "Rank", dataIndex: "rank", key: "rank"},
        {title: "Nationality", dataIndex: "nationality", key: "nationality"},
    ];

    const rowSelection = {
        type: "radio",
        selectedRowKeys,
        onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            setSelectedCrewData(rows);
        },
    };

    const footer = isCrewTable
        ? [
            <Button key="cancel" onClick={handlePopupCancel}>
                Cancel
            </Button>,
            <Button
                key="add"
                type="primary"
                disabled={selectedCrewData.length === 0}
                onClick={() => OnAddButtonClick(selectedCrewData, recoveryIndexPopup)}
            >
                Add Selected
            </Button>,
        ]
        : null;

    return (
        <Modal
            title="Seafarer Records"
            open={visible}
            onCancel={handlePopupCancel}
            footer={footer}
            width={960}
            closable={true}
        >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 gap-y-4">
                <div>
                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">PCN</div>
                    <Input
                        value={crewData.pcn}
                        onChange={handleInputChange("pcn")}
                        onPressEnter={handleSearch}
                        placeholder="e.g. CRW-04412"
                    />
                </div>
                <div>
                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">First Name</div>
                    <Input
                        value={crewData.forename}
                        onChange={handleInputChange("forename")}
                        onPressEnter={handleSearch}
                        placeholder="First name"
                    />
                </div>
                <div>
                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Last Name</div>
                    <Input
                        value={crewData.surname}
                        onChange={handleInputChange("surname")}
                        onPressEnter={handleSearch}
                        placeholder="Last name"
                    />
                </div>
                <div>
                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Rank</div>
                    <Input
                        value={crewData.rank}
                        onChange={handleInputChange("rank")}
                        onPressEnter={handleSearch}
                        placeholder="Rank"
                    />
                </div>
                <div>
                    <div className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide mb-1.5">Nationality</div>
                    <Input
                        value={crewData.nationality}
                        onChange={handleInputChange("nationality")}
                        onPressEnter={handleSearch}
                        placeholder="Nationality"
                    />
                </div>
                <div className="flex items-end justify-end">
                    <Button type="primary" onClick={handleSearch} loading={loading} className="w-full sm:w-auto">
                        Search
                    </Button>
                </div>
            </div>

            {isCrewTable && (
                <div className="mt-4">
                    <Table
                        dataSource={crewItems}
                        columns={columns}
                        loading={loading}
                        onChange={handleTableChange}
                        pagination={{
                            showSizeChanger: false,
                            total: listPagination.totalItemCount,
                            pageSize: listPagination.pageSize,
                            current: listPagination.pageNumber,
                        }}
                        rowKey={(record) => record?.pcn}
                        rowSelection={rowSelection}
                        size="middle"
                        locale={{emptyText: "No seafarers match these criteria."}}
                    />
                </div>
            )}
        </Modal>
    );
};

export default CrewRecoveryPopup;
